<template>
  <div class="search-results-main-skeleton flex">
    <div
      v-if="areResultsAvailable"
      class="w-full"
    >
      <SkeletonLoader
        :number-of-items="24"
        height="753px"
        width="100%"
        class="product-listing flex flex-col items-center gap-10 justify-center grid lg:grid"
      />
    </div>

    <div
      v-else
      class="w-full"
    >
      <SkeletonLoader
        height="325px"
        class="max-w-5xl gap-4 lg:gap-8 p-10 lg:px-32 lg:py-16 bg-EXPONDO-grey-5 mb-10 lg:mb-14 mx-auto"
      />

      <div class="lg:block hidden">
        <SkeletonLoader
          width="90%"
          height="40px"
          class="mb-10"
          item-classes="mx-auto"
        />
        <SkeletonLoader
          :number-of-items="4"
          width="22%"
          height="222px"
          class="w-full flex justify-between mb-8"
        />
        <SkeletonLoader
          :number-of-items="4"
          width="22%"
          height="50px"
          class="w-full flex justify-between mb-24"
        />
      </div>
      <div class="department-block lg:hidden block">
        <SkeletonLoader
          width="90%"
          height="160px"
          class="mb-6 lg:hidden block"
          item-classes="mx-auto"
        />
        <div class="grid grid-cols-2 gap-6 px-5 mb-12">
          <div
            v-for="index in 4"
            :key="index"
            class="mb-4"
          >
            <SkeletonLoader
              height="118px"
              class="mb-6"
            />
            <SkeletonLoader
              height="50px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'SearchResultsMainSkeleton',
  props: {
    areResultsAvailable: {
      type: Boolean,
      default: false,
    },
  },
});

</script>
<style lang="scss">
  .search-results-main-skeleton {
    &__sidebar {
      width: var(--product-card-width);
    }
  }
</style>
